export default "__VITE_ASSET__B2GzLP8y__"